export default "__VITE_ASSET__3ZF0GtnL__"